import { render } from "./icon-plus.vue?vue&type=template&id=1662a711"
import script from "./icon-plus.vue?vue&type=script&lang=js"
export * from "./icon-plus.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__